import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Link, useNavigate } from 'react-router-dom'
import { useRef, useState, useEffect } from 'react'
import { useTheme } from '../context/ThemeProvider'
import login from '../img/login-bg.png'
import axios from '../api/axios'
import useAuth from '../hooks/useAuth'
const LOGIN_URL = '/login'

const Login = () => {
  const { bypassOrg } = useAuth()
  const navigate = useNavigate()
  const theme = useTheme()
  const logo = theme?.logo
  const emailRef = useRef()
  const errRef = useRef()
  const hoverText = theme?.brand === 'swb' ? 'hover:text-violet-400' : 'hover:text-portal-medium'
  const [email, setEmail] = useState('')
  const [pwd, setPwd] = useState('')

  const [errMsg, setErrMsg] = useState('')

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    emailRef.current.focus()
  }, [])

  useEffect(() => {
    setErrMsg('')
  }, [email, pwd])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const response = await axios.post(LOGIN_URL, { email, password: pwd, bypassOrg: bypassOrg })

      const user = response.data.result.user
      let id = user.id
      localStorage.setItem('login', true)
      setEmail('')
      setPwd('')
      navigate('/2fa', { state: id })

    } catch (error) {
      if (!error?.response) {
        setErrMsg('No Server Response')
      } else if (error.response?.status === 400) {
        setErrMsg('Email or Password Missing.')
      } else if (error.response?.status === 401) {
        setErrMsg('Incorrect Email or Password entered.')
      } else if (error.response?.status === 404) {
        setErrMsg('User not found. Please check your credentials.')
      } else if (error.response?.status === 403) {
        setErrMsg('Account Pending. Please wait while we verify you.')
      } else {
        setErrMsg('Error Occurred. Could not log you in.')
      }
      errRef.current.focus()
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="min-h-screen bg-cover bg-center px-8 relative"
      style={{ backgroundImage: `url(${login})` }}
    >
      <div className="max-w-lg mx-auto w-full space-y-4 md:space-y-6 sm:p-8 md:absolute md:top-[18%] md:right-[20%]">
        <div>
          <div className="pt-16 md:pt-0 flex items-center gap-3 pb-2 leading-tight tracking-wider text-[#360F41] dark:text-white">
            <img src={logo} alt="SWB Logo" className="h-20 w-auto" />
            <div>
             {theme.brand === 'swb' ? ( <h1 className="text-2xl md:text-3xl font-bold">
                School Wellbeing Staff Portal
              </h1>) : (
                <h1 className="text-2xl md:text-3xl font-bold text-[#171960]">
                Be Well Support Staff Portal
              </h1>
              )}
            </div>
          </div>
          <h2 className="text-sm md:text-base font-medium">
            Welcome! To login, enter your details below.
          </h2>
        </div>

        <p
          ref={errRef}
          className={errMsg ? 'errmsg text-red-600 text-sm' : 'offscreen'}
          aria-live="assertive"
        >
          {errMsg}
        </p>

        <form
          onSubmit={handleSubmit}
          className="space-y-4 md:space-y-4 max-w-md mx-auto"
        >
          <div className="w-full">
            <label
              htmlFor="email"
              className="block mb-2 text-sm font-medium text-gray-700 dark:text-white"
            >
              Email
            </label>
            <input
              type="email"
              ref={emailRef}
              id="email"
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Email"
              className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:outline-none block w-full p-2.5 
                dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white
                ${
                  theme?.brand === 'swb'
                    ? 'focus:border-violet-300 focus:ring-1 focus:ring-violet-300'
                    : 'focus:border-hub-primary-light focus:ring-1 focus:ring-hub-primary-light'
                }`}
            />
          </div>

          <div>
            <label
              htmlFor="pwd"
              className="block mb-2 text-sm font-medium text-gray-700 dark:text-white"
            >
              Password
            </label>
            <input
              type="password"
              id="pwd"
              onChange={(e) => setPwd(e.target.value)}
              required
              placeholder="Password"
              className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:outline-none block w-full p-2.5 
                dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white
                ${
                  theme?.brand === 'swb'
                    ? 'focus:border-violet-300 focus:ring-1 focus:ring-violet-300'
                    : 'focus:border-hub-primary-light focus:ring-1 focus:ring-hub-primary-light'
                }`}
            />
          </div>
          <div>
            {loading ? (
            <div className="w-full bg-portal-light hover:bg-portal-medium text-white font-semibold py-2 px-4 rounded-lg cursor-pointer transition text-center mt-2">
              Loading... <FontAwesomeIcon icon={faSpinner} spin className="ml-2" />
            </div>
            ) : (
              <button className="w-full bg-portal-light hover:bg-portal-medium text-white font-semibold py-2 px-4 rounded-lg cursor-pointer transition text-center mt-2">
              Login
            </button>
            )}

            <div className="flex justify-between items-center text-xs font-medium text-gray-500 dark:text-primary-500 mt-4">
              <Link
                to={bypassOrg ? '/create-account/step-2' : '/create-account/step-1'}
                className={hoverText}
                role="button"
              >
                Don't have an account? Sign up here
              </Link>
              <Link
                to="/forgot-password"
                className={hoverText}
                role="button"
              >
                Forgot Password?
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Login
